import React from "react";
import { Table, Skeleton } from "antd";
import Column from "antd/es/table/Column";

import NoDataIcon from "../../../assets/svg/no-data.svg";
import { useTranslation } from "react-i18next";

const ConstituencyDataTable = ({
  isDataAvailable,
  data,
  constituencyLoading,
  constituencyDataType
}) => {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem("user")) 
  const themes = localStorage.getItem("themes") 
  return (
    <>
      {isDataAvailable ? (
        <Table
          rowKey={(record) => record.type}
          scroll={{ x: "max-content" }}
          dataSource={data}
          locale={{
            emptyText:
              constituencyLoading || !data ? (
                <div
                  style={{
                    marginLeft: "20px",
                    marginTop: "20px",
                    width: "95%"
                  }}
                >
                  {" "}
                  <Skeleton
                    title={false}
                    active
                    paragraph={{
                      rows: 5,
                      width: ["100%", "100%", "100%", "100%", "100%"],
                      height: ["30px", "30px", "30px", "30px", "30px"]
                    }}
                  />
                </div>
              ) : (
                <div className='no-data-icon mt-20'>
                  <img src={NoDataIcon} alt='' />
                  <h1>{t("No Data Available")}</h1>
                </div>
              )
          }}
        >
          <Column
            title='Party'
            dataIndex='partyName'
            render={(text, record) => {
              let color = record.partyColorCode;

              if (text === "total") {
                color = themes === 'darkMode' ? "#fff" : record.partyColorCode;
              } else if (text === "others") {
                color = themes === 'darkMode' ? "#D3D3D3" : record.partyColorCode;
              }

              return (
                <span
                  style={{
                    fontWeight: "bold",
                    color: color
                  }}
                >
                  {text}
                </span>
              );
            }}
          />

          <Column
            title='Vote Share'
            dataIndex='voteShare'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />

          <Column
            title='Vote Share%'
            dataIndex='voteSharePercentage'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined
                  ? `${parseFloat(text).toFixed(2)}%`
                  : "-"}
              </div>
            )}
          />

          <Column
            // title={constituencyDataType==='central'?'Assemblies':'Villages'}
            title={constituencyDataType==='central'?'Assemblies':(user?.urbanRural==='Urban' ? t("Wards") :t("Villages"))}
            dataIndex='noOfVillageWon'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />

          <Column
            title='Polling Station'
            dataIndex='noOfPSWon'
            render={(text) => (
              <div style={{ textAlign: "center" }}>
                {text !== null && text !== undefined ? text : "-"}
              </div>
            )}
          />
        </Table>
      ) : (
        !constituencyLoading ? 
        (<div className='no-data-icon'>
          <img src={NoDataIcon} alt=''></img>
          <h1>{t("No Data Available")}</h1>
        </div>) : 
        (<div
            style={{
              marginLeft: "20px",
              marginTop: "20px",
              width: "95%"
            }}
          >
            {" "}
            <Skeleton
              title={false}
              active
              paragraph={{
                rows: 5,
                width: ["100%", "100%", "100%", "100%", "100%"],
                height: ["30px", "30px", "30px", "30px", "30px"]
              }}
            />
          </div>)
      )} 
    </>
  );
};

export default ConstituencyDataTable;
